import { DestroyRef, Injectable, Injector, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

const APP_NAME_KEY = 'ERRORS.DOCUMENT_TITLES.APP_NAME';
const APP_NAME_FALLBACK = 'Ticket App';
const SEPARATOR = ' - ';

@Injectable({ providedIn: 'root' })
export class I18nTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly injector = inject(Injector);
  private readonly destroyRef = inject(DestroyRef);
  private translate: TranslateService | null = null;
  private currentKey: string | null = null;

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    this.currentKey = this.buildTitle(snapshot) ?? null;
    this.applyTitle();
  }

  private translateService(): TranslateService {
    if (!this.translate) {
      this.translate = this.injector.get(TranslateService);
      this.translate.onLangChange
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => this.applyTitle());
    }

    return this.translate;
  }

  private applyTitle(): void {
    const appName = this.resolve(APP_NAME_KEY) ?? APP_NAME_FALLBACK;
    const page = this.currentKey ? this.resolve(this.currentKey) : null;

    this.title.setTitle(page ? `${page}${SEPARATOR}${appName}` : appName);
  }

  private resolve(key: string): string | null {
    const value = this.translateService().instant(key) as string;

    return value && value !== key ? value : null;
  }
}
